var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApiError } from '../errors';
/**
 * Is called by the `RequestManager` to make the request over the network.
 *
 * Responsible for:
 * - Throwing ApiErrors for non-200 level errors
 * - Parsing response bodies
 */
export class ApiRequestFetcher {
    constructor() {
        this.getResponse = (params) => __awaiter(this, void 0, void 0, function* () {
            const request = this.createRequest(params);
            const response = yield fetch(request);
            const { responseBody, responseType } = yield this.parseResponseBody(response, params);
            if (!response.ok) {
                throw new ApiError(response.status, responseBody, responseType);
            }
            return { responseBody, responseType };
        });
    }
    /**
     * Generates a `Request` instance to be passed directly to `fetch`
     */
    createRequest(params) {
        return new Request(params.url, {
            method: params.method,
            body: params.body,
            headers: params.headers
        });
    }
    /**
     * Parses response body from `fetch`'s `Response`
     */
    parseResponseBody(response, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const responseType = params.responseType ||
                this.inferResponseTypeUsingContentType(response.headers.get('Content-Type'));
            if (!responseType) {
                return { responseBody: null, responseType: null };
            }
            const responseBody = yield (() => {
                switch (responseType) {
                    case 'json':
                        return response.json();
                    case 'text':
                        return response.text();
                    case 'blob':
                        return response.blob();
                    default:
                        throw new TypeError(`'${responseType}' is not a valid response type`);
                }
            })();
            return { responseBody, responseType };
        });
    }
    /**
     * Attempts to infer the response type for parsing using the
     * 'Content-Type' header
     */
    inferResponseTypeUsingContentType(contentType) {
        if (!contentType) {
            return null;
        }
        if (contentType === 'application/json') {
            return 'json';
        }
        if (['application/', 'image/', 'video/'].some((prefix) => contentType.startsWith(prefix))) {
            return 'blob';
        }
        if (contentType.startsWith('text/')) {
            return 'text';
        }
        return null;
    }
}
//# sourceMappingURL=index.js.map